<template>
<v-expansion-panels>
    <v-expansion-panel>
        <v-expansion-panel-header class="px-1">
            <v-row class="mx-1">
                <v-col cols="8">
                    <div class="regular font-weight-bold">
                        {{ room.name._value }}
                        <span class="faded">({{ room.roomreservation_id._value }})</span>
                        <span>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <span v-if="room.numberofguests._value < 3">
                                        <span v-for="(adult, index) in Number(room.numberofguests._value)" :key="'adult_'+index">
                                            <v-icon v-on="on" size="24">person</v-icon>
                                        </span>
                                    </span>
                                    <span v-else>
                                        <v-icon v-on="on" size="24">person</v-icon>X{{ room.numberofguests._value }}
                                    </span>
                                </template>
                                <div>
                                    <div v-if="room.numberofguests._value" class="px-1">{{ room.numberofguests._value }} {{ $tc('reservations.modal.adults', room.numberofguests._value) }}</div>
                                </div>
                            </v-tooltip>
                        </span>
                    </div>
                </v-col>
                <v-col cols="4">
                    <div class="d-flex justify-end align-center pr-2">
                        <span>{{ getDayAndMonth(room.arrival_date._value) }} </span>
                        <v-icon class="px-1">chevron_right</v-icon>
                        <span>{{ getDayAndMonth(room.departure_date._value) }}</span>
                    </div>
                </v-col>
            </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card flat>
                <v-row class="mx-0">
                    <v-col cols="7">
                        <div class="im-label">
                            {{ $t('reservations.modal.meal_type') }}
                        </div>
                        <div class="regular mt-1 mb-3 text-capitalize">
                            {{ room.meal_plan._value }}
                        </div>
                        <div class="im-label">
                            {{ $t('reservations.modal.guest_name') }}
                        </div>
                        <div class="regular mt-1 mb-3 text-capitalize">
                            {{ room.guest_name._value }}
                        </div>
                        <div class="im-label">
                            {{ $t('reservations.modal.occupancy') }}
                        </div>
                        <div class="regular mt-1 mb-3 text-capitalize">
                            {{ room.numberofguests._value }}
                        </div>
                        <div class="im-label">
                            {{ $t('reservations.modal.extra_info') }}
                        </div>
                        <div class="regular mt-1 mb-3 text-capitalize">
                            <span v-if="room.smoking._value !== '1'">
                                <v-icon size="18">smoke_free</v-icon>
                                <span>{{ $t('reservations.modal.no_smoking') }}</span>
                            </span>
                            <span v-else>
                                <v-icon size="18">smoking_rooms</v-icon>
                                <span>{{ $t('reservations.modal.smoking') }}</span>
                            </span>
                        </div>
                    </v-col>
                    <v-col cols="5">
                        <div>
                            <div class="py-1 justify-space-between d-flex" v-for="(price_day, index2) in handleIsArray(room.price)" :key="index2">
                                <div class="detail pr-1" v-if="price_day._attribute">{{ getDayAndMonth(price_day._attribute.date) }}</div>
                                <im-price :price="price_day._value" :currency="room.currencycode._value" fontSize="12" />
                            </div>
                            <v-divider></v-divider>
                        </div>
                        <div class="mt-2 justify-space-between d-flex">
                            <div class="regular">{{ $t('reservations.modal.total_price') }}</div>
                            <div class="important">
                                <im-price :price="room.totalprice._value" :currency="room.currencycode._value" fontSize="14" />
                            </div>
                        </div>
                        <div class="detail" v-if="room.price_details.hotel.extracomponent">
                            Rate includes are:
                            <span v-for="rate in handleIsArray(room.price_details.hotel.extracomponent)">
                                <span v-if="rate._attribute&&(rate._attribute.included == 'yes')">
                                    {{rate._attribute.percentage}} {{rate._attribute.text}},
                                </span>
                            </span>
                        </div>
                        <div class="im-label mt-2">
                            Extra charges <span class="faded orange--text">*not included in final price</span>
                        </div>
                        <div class="justify-space-between d-flex" v-for="(extra_charge, index3) in extraCharges()" :key="'extra_charge_'+index3">
                            <div class="regular">{{ extra_charge.text }}</div>
                            <div class="important">
                                <im-price :price="extra_charge.value" :currency="extra_charge.currency" fontSize="14" />
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</v-expansion-panels>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";
import IMPrice from '../../../small-components/IMPrice.vue';

export default {
    components: {
        'im-price': IMPrice,
    },

    props: {
        room: {
            type: Object,
        },
    },

    methods: {

        getDayAndMonth(date) {
            if(!date) return date;
            // let value = date * 1000;
            return this.$moment(date)
                .locale(this.$vuetify.lang.current)
                .format('DD MMM');
        },

        handleIsArray(value) {
            if(Array.isArray(value)) {
                return value
            } else {
                return [value]
            }
        },

        extraCharges() {
            if(Array.isArray(this.room.price_details.hotel.extracomponent)) {
                let value = []
                this.room.price_details.hotel.extracomponent.forEach(function (item) {
                    if(item._attribute && (item._attribute.included == "no")) {
                        value.push({
                            text: item._attribute.text,
                            value: item._attribute.amount,
                            currency: item._attribute.currency,
                        })
                    }
                })
                return value
            } else {
                return []
            }
        }

    },
}
</script>
